function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "fe5e6308-1e89-4ce8-8c8d-e7ed4a72d158",
  x1: 689.87057,
  y1: 396.55769,
  x2: 776.68053,
  y2: 396.55769,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.3
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b0adbdce-87b5-465c-b00c-1cf2f5493111",
  x1: 631.27384,
  y1: 535.45364,
  x2: 718.08381,
  y2: 535.45364,
  xlinkHref: "#fe5e6308-1e89-4ce8-8c8d-e7ed4a72d158"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M880.85249,505.2494C773.13547,668.24287,722.473,859,527.10189,859S173.35128,700.62046,173.35128,505.2494,349.88639,233.74549,527.10189,151.49879C1102.708-115.64322,1121.87492,140.543,880.85249,505.2494Z",
  transform: "translate(-173.35128 -41)",
  fill: "#3f3d56"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 669.52185,
  cy: 94.22192,
  r: 66.1926,
  fill: "#e6e6e6"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 663.0111,
  cy: 48.64669,
  r: 7.59587,
  fill: "#cbcbcb"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 676.0326,
  cy: 124.60541,
  r: 7.59587,
  fill: "#cbcbcb"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 705.33096,
  cy: 82.28555,
  r: 5.42562,
  fill: "#cbcbcb"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 643.47886,
  cy: 99.64754,
  r: 17.36199,
  fill: "#cbcbcb"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 441.64569,
  cy: 196.22363,
  r: 10.85125,
  fill: "#6c63ff"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 732.45907,
  cy: 224.43687,
  r: 10.85125,
  fill: "#6c63ff"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 603.32925,
  cy: 245.05424,
  r: 6.51075,
  fill: "#e6e6e6"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 102.00171,
  cy: 450.14278,
  r: 6.51075,
  fill: "#e6e6e6"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 487.22092,
  cy: 624.84783,
  r: 6.51075,
  fill: "#e6e6e6"
});

var _ref14 = /*#__PURE__*/React.createElement("polygon", {
  points: "589.224 438.245 585.975 441.473 582.747 438.223 580.581 440.375 583.808 443.625 580.558 446.852 582.71 449.019 585.96 445.791 589.188 449.041 591.354 446.889 588.126 443.639 591.376 440.412 589.224 438.245",
  fill: "#6c63ff"
});

var _ref15 = /*#__PURE__*/React.createElement("polygon", {
  points: "158.43 544.588 155.18 547.815 151.953 544.565 149.786 546.717 153.014 549.967 149.764 553.194 151.916 555.361 155.165 552.133 158.393 555.383 160.56 553.231 157.332 549.982 160.582 546.754 158.43 544.588",
  fill: "#e6e6e6"
});

var _ref16 = /*#__PURE__*/React.createElement("polygon", {
  points: "184.473 355.776 181.223 359.003 177.996 355.754 175.829 357.905 179.057 361.155 175.807 364.383 177.959 366.549 181.208 363.322 184.436 366.571 186.603 364.42 183.375 361.17 186.625 357.942 184.473 355.776",
  fill: "#e6e6e6"
});

var _ref17 = /*#__PURE__*/React.createElement("polygon", {
  points: "751.993 155.028 748.743 158.255 745.516 155.006 743.349 157.157 746.577 160.407 743.327 163.635 745.479 165.801 748.729 162.574 751.956 165.823 754.123 163.672 750.895 160.422 754.145 157.194 751.993 155.028",
  fill: "#e6e6e6"
});

var _ref18 = /*#__PURE__*/React.createElement("polygon", {
  points: "495.904 245.093 492.654 248.321 489.426 245.071 487.26 247.223 490.487 250.472 487.238 253.7 489.389 255.867 492.639 252.639 495.867 255.889 498.033 253.737 494.806 250.487 498.055 247.26 495.904 245.093",
  fill: "#e6e6e6"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M691.79334,446.99143l32.97058-38.59855,32.97057-38.59855,18.61242-21.7895c1.02981-1.2056-.55938-3.08643-1.58915-1.88088L741.78719,384.7225l-32.97057,38.59855L690.2042,445.11056c-1.02982,1.2056.55937,3.08642,1.58914,1.88087Z",
  transform: "translate(-173.35128 -41)",
  opacity: 0.8,
  fill: "url(#fe5e6308-1e89-4ce8-8c8d-e7ed4a72d158)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M633.19662,585.88737l32.97057-38.59855,32.97057-38.59855,18.61242-21.7895c1.02981-1.2056-.55937-3.08643-1.58915-1.88087l-32.97057,38.59855L650.21989,562.217l-18.61242,21.7895c-1.02981,1.2056.55937,3.08643,1.58915,1.88087Z",
  transform: "translate(-173.35128 -41)",
  opacity: 0.8,
  fill: "url(#b0adbdce-87b5-465c-b00c-1cf2f5493111)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M293.52619,331.32164h61.8521a0,0,0,0,1,0,0v24.33858a15.811,15.811,0,0,1-15.811,15.811H309.33722a15.811,15.811,0,0,1-15.811-15.811V331.32164A0,0,0,0,1,293.52619,331.32164Z",
  fill: "#2f2e41"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M549.34694,695.68875c-14.0849,14.27061-28.19145,14.366-42.31946.46l-10.85164-95.95094L488.58,696.34927c-14.11847,11.42686-27.27574,12.96547-39.06448.42461-11.24565-83.07535-17.35815-160.2537-7.59587-219.19516l-20.61737-83.55459,46.66036-21.70249c9.39634,23.24307-5.42324,35.1313,28.08839,34.73339,33.21631-.39441,30.73557-12.88943,29.42321-34.73339l42.92319,16.50892a15.38272,15.38272,0,0,1,9.14663,18.98963l-21.68633,68.6734C564.2064,511.16046,555.63436,607.59438,549.34694,695.68875Z",
  transform: "translate(-173.35128 -41)",
  fill: "#e6e6e6"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M484.23947,779.24335s-34.64058,3.03439-39.281,1.12362h0q-.43935-.18092-.85525-.39352c-6.89625-3.52114-7.10638-13.3821-.66091-17.67309l13.66907-9.1L445.175,689.178l46.1178.54256Z",
  transform: "translate(-173.35128 -41)",
  fill: "#2f2e41"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M510.28246,779.78591s34.64057,3.03439,39.281,1.12363h0q.43935-.18092.85525-.39352c6.89625-3.52114,7.10638-13.3821.66091-17.67309l-13.66907-9.1L554.23,689.72057H505.942Z",
  transform: "translate(-173.35128 -41)",
  fill: "#2f2e41"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M428.89811,551.36719l6.86638,27.46551a16.55029,16.55029,0,0,1-7.20087,17.996l0,0a16.55029,16.55029,0,0,1-25.30968-12.20314L401.77,570.89943l-5.42562-130.45524a54.87781,54.87781,0,0,1,33.85878-50.69295l10.63132-4.40811Z",
  transform: "translate(-173.35128 -41)",
  fill: "#e6e6e6"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M601.43292,439.3606l-.03259.77046-4.38388,105.30046-.84636,20.34609-.16279,4.0367-1.48662,13.72678a16.55048,16.55048,0,1,1-32.51036-5.79453l6.86886-27.4645-.15193-2.04-.91147-12.76107L556.94281,384.258l10.63421,4.4056a54.9579,54.9579,0,0,1,33.8559,50.697Z",
  transform: "translate(-173.35128 -41)",
  fill: "#e6e6e6"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M500.57674,559.19089c-39.41736,0-63.732-13.67-64.07587-13.86818l1.0846-1.8799c.48428.27976,49.24918,27.63359,120.8939,3.923l.68244,2.06A185.89809,185.89809,0,0,1,500.57674,559.19089Z",
  transform: "translate(-173.35128 -41)",
  fill: "#2f2e41"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M461.5451,659.23535c-8.67463-19.51846-8.71861-104.3521-8.716-107.954l2.17025.00212c-.00053.87743.04026,87.97033,8.52946,107.07022Z",
  transform: "translate(-173.35128 -41)",
  fill: "#2f2e41"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M466.05727,660.11066c-7.72727,0-12.86148-1.6457-16.20852-3.533-6.09428-3.43658-7.35161-8.11936-7.40194-8.31646l2.10242-.53832-1.05121.26916,1.04962-.27446c.044.16425,1.14129,4.06286,6.46307,7.02364,5.85956,3.25855,17.65446,5.69054,40.55865-1.2356l.62733,2.077C481.23524,658.89731,472.69094,660.11066,466.05727,660.11066Z",
  transform: "translate(-173.35128 -41)",
  fill: "#2f2e41"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  x: 448.66696,
  y: 382.62543,
  width: 2.17072,
  height: 170.16399,
  transform: "translate(-195.69162 -18.43964) rotate(-2.80385)",
  fill: "#2f2e41"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M535.14707,659.23535l-1.98375-.88166c8.4892-19.09989,8.53052-106.19279,8.52946-107.07022l2.17025-.00212C543.86515,554.88325,543.82171,639.71689,535.14707,659.23535Z",
  transform: "translate(-173.35128 -41)",
  fill: "#2f2e41"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M530.6349,660.11066c-6.63367,0-15.17585-1.21229-26.13942-4.52807l.62734-2.077c22.90418,6.92508,34.69643,4.49521,40.55865,1.2356,5.32177-2.96078,6.41855-6.85939,6.462-7.02364l2.10137.54362c-.05087.1971-1.30766,4.87988-7.40195,8.31646C543.49638,658.465,538.36005,660.11066,530.6349,660.11066Z",
  transform: "translate(-173.35128 -41)",
  fill: "#2f2e41"
});

var _ref33 = /*#__PURE__*/React.createElement("rect", {
  x: 461.85785,
  y: 466.62206,
  width: 170.16399,
  height: 2.17072,
  transform: "translate(-120.26149 950.16282) rotate(-87.20185)",
  fill: "#2f2e41"
});

var _ref34 = /*#__PURE__*/React.createElement("polygon", {
  points: "355.248 367.131 339.101 391.003 304.377 391.003 292.767 367.131 297.867 367.131 306.548 386.663 335.846 386.663 349.953 367.131 355.248 367.131",
  fill: "#6c63ff"
});

var _ref35 = /*#__PURE__*/React.createElement("polygon", {
  points: "394.443 379.067 394.725 379.631 394.443 380.152 394.443 379.067"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M603.60317,439.3606l-.03259.77046-20.58478,5.97905-12.73935-25.47877,13.03236-23.8944A54.80994,54.80994,0,0,1,603.60317,439.3606Z",
  transform: "translate(-173.35128 -41)",
  fill: "#6c63ff"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M395.00956,439.3606l.03259.77046,20.58478,5.97905,12.73935-25.47877-13.03236-23.8944A54.80994,54.80994,0,0,0,395.00956,439.3606Z",
  transform: "translate(-173.35128 -41)",
  fill: "#6c63ff"
});

var _ref38 = /*#__PURE__*/React.createElement("circle", {
  cx: 324.45224,
  cy: 291.71459,
  r: 57.5116,
  fill: "#e6e6e6"
});

var _ref39 = /*#__PURE__*/React.createElement("circle", {
  cx: 324.45224,
  cy: 299.31046,
  r: 42.31986,
  fill: "#2f2e41"
});

var _ref40 = /*#__PURE__*/React.createElement("polygon", {
  points: "424.284 504.432 423.403 524.778 395.571 509.825 394.849 507.242 393.9 494.481 424.284 504.432",
  fill: "#6c63ff"
});

var _ref41 = /*#__PURE__*/React.createElement("polygon", {
  points: "226.324 504.432 227.25 524.778 256.503 509.825 257.263 507.242 258.26 494.481 226.324 504.432",
  fill: "#6c63ff"
});

var _ref42 = /*#__PURE__*/React.createElement("polygon", {
  points: "339.678 392.089 303.698 392.089 283.777 351.139 282.753 336.41 284.918 336.26 285.913 350.568 305.057 389.918 338.525 389.918 363.075 353.628 368.301 337.605 370.366 338.277 364.958 354.718 339.678 392.089",
  fill: "#2f2e41"
});

var SvgAstrounot = function SvgAstrounot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e2652d7b-d014-44e7-aeea-709bf92e6067",
    "data-name": "Layer 1",
    width: 853.29744,
    height: 818,
    viewBox: "0 0 853.29744 818",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAstrounot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/astrounot.23ee41ce.svg";
export { ForwardRef as ReactComponent };